import React, {useRef} from "react";

class SvgSprite extends React.Component{
    render(){
        const section = this.props.section || 'common'
        const href = `/static/championship/image/svg/sprites/${section}.svg#${this.props.id}`
        return (
            <div className="svg-icon">
                <svg>
                    <use href={href}></use>
                </svg>
            </div>
        )
    }
}

export default SvgSprite